import { motion } from "framer-motion";

/**
 * Fade-up reveal that triggers when the element enters the viewport.
 * Subtle, single-shot. Honours user reduced-motion via `whileInView` defaults.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 28,
  duration = 0.9,
  className = "",
  as = "div",
  amount = 0.2,
  testId,
}) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      data-testid={testId}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      {children}
    </MotionTag>
  );
}
